import React from "react";
import { Box, Typography, Grid, Paper, Tooltip } from "@mui/material";
// TODO(api): Replace direct gamificationService import with API call
// import { // TODO(shared): Replace badgesConfig with shared constant
// badgesConfig, // TODO(shared): Replace tiers with shared constant
// tiers } from '../services/gamificationService';

// Fallback definitions for tiers and badgesConfig
const tiers = [
    { name: "Bronze", minInvestment: 1000, icon: "🥉" },
    { name: "Silver", minInvestment: 5000, icon: "🥈" },
    { name: "Gold", minInvestment: 10000, icon: "🥇" },
    { name: "Platinum", minInvestment: 25000, icon: "💎" },
    { name: "Diamond", minInvestment: 50000, icon: "💠" },
];

const badgesConfig = {
    firstInvestment: { name: "First Investment", description: "Made your first investment", icon: "🎯" },
    consistentInvestor: { name: "Consistent Investor", description: "Invested in 5+ opportunities", icon: "📈" },
    highRoller: { name: "High Roller", description: "Invested $10,000+ in total", icon: "💰" },
    earlyBird: { name: "Early Bird", description: "Invested in an opportunity within 24h of launch", icon: "🐦" },
    portfolioDiversifier: { name: "Portfolio Diversifier", description: "Invested in 3+ different sectors", icon: "🌐" },
    communitySupporter: { name: "Community Supporter", description: "Participated in 10+ community discussions", icon: "🤝" },
};

// Add Newcomer tier to the tiers array if it doesn't exist
const allTiers = [
    { name: "Newcomer", minInvestment: 0, icon: "🌱" },
    ...tiers,
];

const AchievementCard = ({ title, userTier, userBadges = [] }) => {
    const getTierDetails = (tierName) => {
    // First try to find the tier in the gamification service tiers
        let tierDetails = tiers.find(t => t.name === tierName);
    
        // If not found, check in our extended tiers array
        if (!tierDetails) {
            tierDetails = allTiers.find(t => t.name === tierName);
        }
    
        // If still not found, return Newcomer as default
        return tierDetails || { name: "Newcomer", icon: "🌱" };
    };
  
    const tierDetails = getTierDetails(userTier);

    return (
        <Paper elevation={3} sx={{ p: 3, mb: 4 }}>
            <Typography variant="h5" gutterBottom>
                {title}
            </Typography>
            <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
                <Typography variant="h6" sx={{ mr: 2 }}>Your Tier:</Typography>
                <Tooltip title={`Current Tier: ${tierDetails.name}`}>
                    <Box sx={{ fontSize: "2rem" }}>{tierDetails.icon}</Box>
                </Tooltip>
                <Typography variant="h6" sx={{ ml: 1 }}>{tierDetails.name}</Typography>
            </Box>
            <Typography variant="h6" gutterBottom>
        Your Badges
            </Typography>
            <Grid container spacing={2}>
                {Object.keys(badgesConfig).map((badgeKey) => {
                    const badge = badgesConfig[badgeKey];
                    const hasBadge = userBadges.includes(badgeKey);
                    return (
                        <Grid item xs={4} md={2} key={badgeKey}>
                            <Tooltip title={`${badge.name}: ${badge.description}`}>
                                <Box
                                    sx={{
                                        filter: hasBadge ? "none" : "grayscale(100%)",
                                        opacity: hasBadge ? 1 : 0.4,
                                        textAlign: "center",
                                    }}
                                >
                                    <Box sx={{ fontSize: "3rem" }}>{badge.icon}</Box>
                                    <Typography variant="caption">{badge.name}</Typography>
                                </Box>
                            </Tooltip>
                        </Grid>
                    );
                })}
            </Grid>
        </Paper>
    );
};

export default AchievementCard;